import { Service } from "@turizi/shared";

export const TourTemplate: Partial<Service> = {
    category: 'tour',
    required_service_orders: 1,

    self_attrs: [
        {
            key: 'tour_path',
            type: 'text',
            value: null,
            section: 'info_0',
            sort: 0,
            description: 'Ruta del tour',
        },
        {
            key: 'tour_type',
            type: 'text',
            value: null,
            section: 'info_0',
            sort: 1,
            description: 'Tipo de tour',
            options: ['Lacustre', 'Terrestre', 'Aéreo'],
        },
        {
            key: 'duration', // hours
            type: 'text',
            value: null,
            section: 'routing_3',
            description: 'Duration in hours',
            sort: 6,
        },
        {
            key: 'regular_schedule',
            type: 'boolean',
            value: true,
            description: 'Servicio regular con horarios fijos',
            section: 'scheduling_4',
            sort: 8,
        },
        {
            key: 'time_range',
            type: 'text',
            value: null,
            description: 'Rango de horarios o restricciones: ej: 08:00-18:00, Nocturno, Solo mañana, etc.',
            section: 'scheduling_5',
            sort: 9,
        },
        {
            key: 'shared_vehicle',
            type: 'boolean',
            value: true,
            description: 'Servicio grupal, compartido con otros clientes',
            section: 'vehicle_5',
            sort: 7,
        },
        {
            key: 'vehicle_type',
            type: 'text',
            value: null,
            description: 'Tipo de vehículo',
            section: 'vehicle_5',
            options: ['Van', 'Bus', 'Minibus', 'Auto'],
            sort: 9,
        },
    ],
    booking_attrs: [
        {
            key: 'origin_address',
            type: 'text',
            value: null,
            blocked: true,
            sort: 2,
        },
        {
            key: 'destination_address',
            type: 'text',
            value: null,
            blocked: true,
            sort: 3,
        },
    ]

} as const;

export default TourTemplate;